import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import {Link, withRouter} from 'react-router-dom'

import {AppBar, Button, Toolbar, Typography, withStyles, Grid} from '@material-ui/core'
import AddIcon from '@material-ui/icons/CloudUpload'
import SettingsIcon from '@material-ui/icons/Settings'
import LogoutIcon from '@material-ui/icons/ExitToApp'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import {authActions, projectActions} from '../../core/actions'
import HeaderStyles from './Header.styles'
import ArrowToolTip from '../../components/ArrowToolTip/ArrowToolTip'
import LoginModal from '../../components/LoginModal/LoginModal'

const mapStateToProps = state => ({
    auth: {
        user: state.auth.user
    },
    project: {
        projectDetails: state.project.projectDetails
    }
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({...projectActions, ...authActions}, dispatch)
})

class Header extends Component {

    state = {
        currentRoute: ''
    }

    componentDidMount() {
        this.setState({currentRoute: this.props.location.pathname})
        this.props.history.listen(location => {
            this.setState({currentRoute: location.pathname})
        })
    }
    getLoginModal = modal => (this.loginModal = modal)
    showLoginModal = () => this.loginModal.toggleOpen(true)()

    crumb = (name, linkTo) => (
        <div className={this.props.classes.crumbContainer}>
            <KeyboardArrowRight />
            <Typography variant="h6" color="inherit">
                <Link to={linkTo} className={this.props.classes.link}>
                    {name}
                </Link>
            </Typography>
        </div>
    )

    showBreadCrumbs = () => {
        const {project: {projectDetails}} = this.props
        const {currentRoute} = this.state

        if (currentRoute === '/') {
            return this.crumb('Browse', '/')
        } else if (currentRoute.match(/^\/\d+$/) !== null) {
            return this.crumb(projectDetails ? projectDetails.name : 'Loading..', currentRoute)
        }
    }

    render() {
        const {classes: styles, auth: {user}} = this.props
        const {logoutUser} = this.props.actions
        const isLoggedIn = user

        return (
            <AppBar position="fixed" className={styles.appBar} color={'primary'}>
                <Grid
                    container
                    justify="center"
                    direction="row"
                >
                    <Grid xl={8} lg={8} md={10} sm={12} xs={12} item>
                        <Toolbar className={styles.toolbar}>
                            <div className={styles.titleContainer}>
                                <Typography variant="h6" color="inherit">
                                    <Link to={'/'} className={styles.link}>
                                        Projects
                                    </Link>
                                </Typography>
                                {this.showBreadCrumbs()}
                            </div>
                            {!isLoggedIn ? <Button onClick={this.showLoginModal} className={styles.menuButton} color="inherit">Login</Button>
                                : (
                                    <div>
                                        <Link to={'/create'}>
                                            <ArrowToolTip title="Upload Project">
                                                <Button className={styles.menuButton} color="inherit">
                                                    <AddIcon className={styles.iconMenuButton} />
                                                </Button>
                                            </ArrowToolTip>
                                        </Link>

                                        <Link to={'/conf'}>
                                            <ArrowToolTip title="Settings">
                                                <Button className={styles.menuButton} color="inherit">
                                                    <SettingsIcon className={styles.iconMenuButton} />
                                                </Button>
                                            </ArrowToolTip>
                                        </Link>

                                        <ArrowToolTip title="Logout">
                                            <Button className={styles.menuButton} color="inherit" onClick={logoutUser}>
                                                <LogoutIcon className={styles.iconMenuButton} />
                                            </Button>
                                        </ArrowToolTip>
                                    </div>
                                )
                            }
                        </Toolbar>
                    </Grid>
                </Grid>
                {!isLoggedIn && <LoginModal innerRef={this.getLoginModal} /> }
            </AppBar>
        );
    }
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    actions: PropTypes.object,
    project: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(HeaderStyles)(withRouter(Header)))
